import React from "react";

// /deleteAccount. SpotSaver app users delete their account themselves: in the app
// (Profile > Delete Account) or, without the app, on the public deletion page on
// myspotsaver.com, which has no session recording (this portal loads Clarity on every
// page, so the form deliberately does not live here). Its address comes from the config
// document's common.accountDeletionPageUrl, so staging links to the staging copy.
const PROD_PAGE = "https://myspotsaver.com/delete-account.html";

const DeleteAccount = () => {
    const pageUrl = window?.site?.common?.accountDeletionPageUrl || PROD_PAGE;
    const supportEmail = window?.site?.admin?.supportEmail || "support@myspotsaver.com";
    return (
        <main>
            <div className="error-wrapper">
                <h1>Delete your SpotSaver account</h1>
                <h4>
                    Use the SpotSaver app? Delete your account in the app under <b>Profile → Delete Account</b>,
                    or without the app at <a href={pageUrl}>{pageUrl.replace(/^https:\/\//, "")}</a>.
                </h4>
                <h4>
                    <a className="fill-btn-style mt-3" href={pageUrl}>Request account deletion</a>
                </h4>
                <h4>
                    To close a venue (business) account, email us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
                </h4>
            </div>
        </main>
    );
};

export default DeleteAccount;
